import React from 'react';
import { FormattedMessage } from 'react-intl';
import { isTestEnvironment } from '../utils/environment';
import styles from './TestVersionBanner.module.css';
/**
 * Persistent warning banner announcing that this is a test instance of ReČeK
 * and that any assigned ISBN/ISMN are not valid outside it.
 *
 * `placement="top"` (default) is the full-width bar used below the main
 * navigation and on pre-login screens without a logo; `placement="inline"` is
 * the boxed variant shown between the logo and the form on the login screens
 * (see PreLoginBannerProvider). Visibility is gated by {@link isTestEnvironment} so the
 * banner never shows in production. The message is fully localized via i18n
 * (no hard-coded copy).
 */
var TestVersionBanner = function (_a) {
    var _b = _a.placement, placement = _b === void 0 ? 'top' : _b;
    if (!isTestEnvironment())
        return null;
    return (React.createElement("div", { className: placement === 'inline' ? "".concat(styles.banner, " ").concat(styles.inline) : styles.banner, role: "status", "aria-live": "polite" },
        React.createElement("span", { className: styles.icon, "aria-hidden": "true" }, "\u26A0"),
        React.createElement("span", { className: styles.text },
            React.createElement("strong", { className: styles.heading },
                React.createElement(FormattedMessage, { id: "stripes-core.recek.testVersionBanner.heading" })),
            React.createElement("span", { className: styles.body },
                React.createElement(FormattedMessage, { id: "stripes-core.recek.testVersionBanner.body" })))));
};
export { TestVersionBanner };
